import { render, staticRenderFns } from "./dev-online.vue?vue&type=template&id=70486c60&scoped=true&"
import script from "./dev-online.vue?vue&type=script&lang=js&"
export * from "./dev-online.vue?vue&type=script&lang=js&"
import style0 from "./dev-online.vue?vue&type=style&index=0&id=70486c60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70486c60",
  null
  
)

export default component.exports